module.exports = __webpack_public_path__ + "static/media/Levin_Range_Seat_2 Lighting 3.6c4c5b40.jpg";